<template>
<v-layout :column="!horizontal" >
    <v-flex v-for="parent in menuItems" :key="parent.Text" shrink>
        <v-menu v-if="parent.Children.length > 0 && showMenu" :offset-y="horizontal" :offset-x="!horizontal" :open-on-hover="!parent.IsRoot" full-width :close-on-content-click="false" transition="slide-x-transition" max-height="85%" :value="menuOpen.indexOf(parent.Text) >= 0" @input="handleMenuOpenClose(parent.Text, $event)">
            <v-list slot="activator" class="nav-item" dense>
                <v-list-tile>
                    <v-list-tile-title v-text="parent.Text"></v-list-tile-title>
                    <v-icon v-if="parent.IsRoot" color="primary" size="25px">arrow_drop_down</v-icon>
                    <v-icon v-else color="primary" size="15px">play_arrow</v-icon>
                </v-list-tile>
            </v-list>
            <Menu :menuItems="parent.Children" :horizontal="false" @url-clicked="navigate($event.route, $event.newTab, parent.Text)" v-if="showMenu" ></Menu>
        </v-menu>
        <v-list dense v-else>
            <v-list-tile @click="() => {}" @mouseup="handleMouseUp($event, parent.Href, parent.Text)">
                <v-list-tile-title v-text="parent.Text"></v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-flex>
</v-layout>
</template>

<script>
export default {
    name: "nav-menu",
    props: ['menuItems', 'horizontal'],
    data(){
        return {
            menuOpen: []
        };
    },
    computed: {
        showMenu() {
            return !this.$store.state.GeneralStore.loadingRoute;
        }
    },
    components: {
        Menu: () => import('@/components/navigation/Menu.vue')
    },
    methods: {
        handleMenuOpenClose(parentText, value){
            let index = this.menuOpen.indexOf(parentText);
            if(index >= 0 && value == false){
                this.menuOpen.splice(index, 1);
            }

            if(index < 0 && value == true){
                this.menuOpen.push(parentText);
            }
        },
        navigate(route, newTab = false, parentText = null) {
            if(parentText != null){
                this.handleMenuOpenClose(parentText, false);
            }

            this.$emit('url-clicked', {
                route,
                newTab
            })
        },
        handleMouseUp(event, route, parentText){
            if(event.button == 0 && !event.ctrlKey){
                this.navigate(route, false, parentText);
            } else if(event.button == 1 || event.ctrlKey){
                this.navigate(route, true, parentText);
            }
        }
    }
}
</script>

<style>
    .nav-item {
        width: 100%
    }
</style>
